import * as C from "parser-ts/lib/char";
import * as S from "parser-ts/lib/string";
import * as P from "parser-ts/lib/Parser";
import { pipe } from "fp-ts/lib/function";
import { Either } from "fp-ts/lib/Either";
import { run } from "parser-ts/lib/code-frame";

export class UGParser {
  protected static parse<T>(
    parser: P.Parser<string, T>
  ): (input: string) => Either<string, T> {
    return (input: string) => run(only(parser), input);
  }
}

/// only(parser) returns a parser that succeeds if the parser consumes all of the input
export const only = <I, A>(parser: P.Parser<I, A>) =>
  pipe(
    parser,
    P.chainFirst((_) => P.eof())
  );

export const singleQuotedString: P.Parser<string, string> = pipe(
  C.many(P.either(S.string("\\'"), () => C.notChar("'"))),
  P.surroundedBy(C.char("'"))
);

export const skip = P.chainFirst;
